<template>
    <LayoutForm>
        <template slot="header">
            <a href="#" @click.prevent="$router.back()">Back</a>
            <h1>Edit Document Category</h1>
        </template>
        <form class="form" @submit.prevent="submit" novalidate v-if="!isLoading">
            <ValidationAlert :error-list="errors.collect('server')" />
            <fieldset class="form__group">
                <div class="form__group">
                    <input
                        id="name"
                        class="form__control"
                        type="text"
                        name="name"
                        placeholder="Enter a category name..."
                        v-model="formData.name"
                        v-validate="'required'"
                    />
                    <label for="name" class="form__label">Category name</label>
                </div>
                <div class="form__group">
                    <textarea
                        id="description"
                        class="form__control"
                        type="description"
                        name="name"
                        placeholder="Enter a short category description..."
                        v-model="formData.description"
                    />
                    <label for="name" class="form__label">Category Description (optional)</label>
                </div>
                <FormControlInsightCategory
                    v-model="formData.parent"
                    label="Select a parent category (optional)"
                    ref="cats"
                    name="parent"
                />
                <FormControlEvent
                    v-model="formData.event"
                    :allow-empty="true"
                    label="Select a related event (optional)"
                    ref="events"
                    name="event"
                />
                <FileUpload
                    id="image"
                    label="Image (optional)"
                    v-model="formData.image"
                    name="image"
                    :multiple="false"
                />
                <div class="form__group form__group--submit">
                    <button class="btn btn--primary" v-wait:disabled='"submit"'>
                        <Spinner :height="13" :width="13" v-if="$wait.is('submit')" />
                        <span v-else>Update</span>
                    </button>
                </div>
            </fieldset>
        </form>
        <div v-else class="loading">
            <Spinner :height="40" :width="40" />
        </div>
    </LayoutForm>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '@api';
import LayoutForm from '@components/Layout/LayoutForm';
import FormControlInsightCategory from '@components/Form/Control/FormControlInsightCategory';
import ValidationAlert from '@components/ValidationAlert';
import Form from '@components/Form/Form';
import Spinner from '@components/Spinner';
import FileUpload from '@components/Form/FileUpload';
import FormControlEvent from '@components/Form/Control/FormControlEvent';

export default {
    name: 'InsightCategoryEditForm',
    mixins: [ Form ],
    components: {
        FormControlEvent,
        FileUpload,
        Spinner,
        ValidationAlert,
        FormControlInsightCategory,
        LayoutForm,
    },
    props: {
        id: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            isLoading: true,
            isWorking: false,
            formData: {
                name: null,
                description: null,
                parent: 0,
                image: null,
                event: null,
            },
            formErrors: [],
        }
    },
    watch: {
        id: function(newVal, oldVal) {
            if(newVal === oldVal)
                return false;

            this.getResource(newVal);
        },
    },
    methods: {
        async getResource() {
            try {
                this.isLoading = true;
                const data = await API.getInsightCategory(this.id);

                this.formData = {
                    name: data.name,
                    description: data.description,
                    parent: data.parent_id,
                    image: data.image ? data.image.uuid : null,
                    event: data.event ? data.event.id : null,
                }

                this.isLoading = false;
            } catch(err) {
                console.log(err);
                console.warn(`[SectorEdit.vue] ${err.message}`);
            }
        },
        async submit(e) {
            const result = await this.$validator.validateAll();

            if(!result || this.$wait.is('submit')) {
                return false;
            }

            this.$wait.start('submit');

            try {
                await API.updateInsightCategory(this.id, this.formData);
                this.$router.push({ name: 'documents' });
            } catch(error) {
                console.log(error);
            } finally {
                // this.isLoading = false;
                this.$wait.end('submit');
            }
        },
    },
    mounted() {
        if(!this.can('createMembers')){
            this.$router.push({ name: 'sector-single-view', params: { id: this.id } });
        }
    },
    created() {
        this.getResource();
    },
    computed: {
        ...mapGetters([ 'can' ]),
    }
}
</script>
